// extracted by mini-css-extract-plugin
var _1 = "PostModalViewCommentThread-module__animateUploadProgressBarWidth--qJWpJ";
var _2 = "PostModalViewCommentThread-module__animatedBackground--vFmJZ";
var _3 = "PostModalViewCommentThread-module__authorName--pqXeg";
var _4 = "PostModalViewCommentThread-module__avatar--t1iMW";
var _5 = "PostModalViewCommentThread-module__comment--f7U2a";
var _6 = "PostModalViewCommentThread-module__commentAvatar--HCRPB";
var _7 = "PostModalViewCommentThread-module__commentContent--ZvxTu";
var _8 = "PostModalViewCommentThread-module__commentMeta--DL2HH";
var _9 = "PostModalViewCommentThread-module__container--VeKjI";
var _a = "PostModalViewCommentThread-module__replyButton--jXQOK";
var _b = "PostModalViewCommentThread-module__time--u0CoW";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "authorName", _4 as "avatar", _5 as "comment", _6 as "commentAvatar", _7 as "commentContent", _8 as "commentMeta", _9 as "container", _a as "replyButton", _b as "time" }
